import allCountries from "assets/data/countries.json"

// Il est normal qu'on l'on ait un décalage entre la date de version "validée" et celle du document sur legal.o-code.co
// Pour éviter de refaire signer tous les clients, nous avons laissé tel quel.
// Commentaire à supprimer dans l'avenir, dès que nous aurons changé les version des CGU
export const MFC_CGU_VERSION = "20210719"
export const BC_CGU_VERSION = "20210719"
export const MC_CGU_VERSION = "20230418"

//CGV
export const BC_CGV = "240102"

export const CGV_LINK = {
	FR: "https://legal.o-code.co/bike/Bicycode/Store/CGV/fr/CGV_STORE.pdf ",
	EN: "https://legal.o-code.co/bike/Bicycode/Store/CGV/en/CGV_STORE_EN.pdf",
}

export const MFC_CGU_LINK = {
	FR: "https://legal.o-code.co/bike/MFC/Store/CGU/fr/CGU_MFC_20240201.pdf",
	EN: "https://legal.o-code.co/bike/MFC/Store/CGU/en/GTU_MFC_2024O2O1.pdf ",
}
export const MC_CGU_LINK = {
	FR: "https://legal.o-code.co/bike/Moustache Bikes/Store/CGU/fr/CGU_Moustache_Bikes_20230401.pdf",
	EN: "https://legal.o-code.co/bike/Moustache Bikes/Store/CGU/en/TOU_Moustache_Bikes_20230401.pdf",
}
export const BC_CGU_LINK = {
	FR: "https://legal.o-code.co/bike/Bicycode/Store/CGU/fr/CGU_Bicycode_20210701.pdf",
	EN: "https://legal.o-code.co/bike/Bicycode/Store/CGU/en/TOU_Bicycode_20230101.pdf",
}

export const MFC_LEGAL_NOTICE = {
	FR: "https://legal.o-code.co/bike/MFC/Store/ML/fr/MentionsLegales_MFC_20210701.pdf",
	EN: "https://legal.o-code.co/bike/MFC/Store/ML/en/LegalNotice_MFC_20240201.pdf",
}
export const MC_LEGAL_NOTICE = {
	FR: "https://legal.o-code.co/bike/Moustache Bikes/Store/ML/fr/MentionsLegales_Moustache_Bikes_20230401.pdf",
	EN: "https://legal.o-code.co/bike/Moustache Bikes/Store/ML/en/LegalNotice_Moustache_Bikes_20230401.pdf",
}
export const BC_LEGAL_NOTICE = {
	FR: "https://legal.o-code.co/bike/Bicycode/Store/ML/fr/MentionsLegales_Bicycode_20211001.pdf",
	EN: "https://legal.o-code.co/bike/Bicycode/Store/ML/en/LegalNotice_Bicycode_20230117.pdf",
}

export const MFC_PRIVACY_POLICY = {
	FR: "https://legal.o-code.co/bike/MFC/Store/PDC/fr/PolitiqueDeConfidentialite_MFC_20210701.pdf",
	EN: "https://legal.o-code.co/bike/MFC/Store/PDC/en/ConfidentialityPolicy_MFC_20240201.pdf",
}
export const MC_PRIVACY_POLICY = {
	FR: "https://legal.o-code.co/bike/Moustache Bikes/Store/PDC/fr/PolitiqueDeConfidentialite_Moustache_Bikes_20230401.pdf ",
	EN: "https://legal.o-code.co/bike/Moustache Bikes/Store/PDC/en/PrivacyPolicy_Moustache_Bikes_20230401.pdf",
}
export const BC_PRIVACY_POLICY = {
	FR: "https://legal.o-code.co/bike/Bicycode/Store/PDC/fr/PolitiqueDeConfidentialite_Bicycode_20210701.pdf",
	EN: "https://legal.o-code.co/bike/Bicycode/Store/PDC/en/PrivacyPolicy_Bicycode_20230117.pdf",
}

export const FAQLinks = {
	FR: "https://faq-store.notion.site/f2f8fd81df3444debb7f8f9024c5fbd4?v=9664306864894128b8f298bfea3a6481",
	EN: "https://faq-store.notion.site/ed8b036decec47ddaf2b98c58ba61b8c?v=730b8dcb9ff14d29a1bb95d6d9906bfa",
}

// AREA CODE
export const METROPOLITAN_FRANCE_AREA_CODE = "+33"

export const ONE_DAY_IN_SECONDS = 86400000

export const countriesList = Object.entries(allCountries).map((item) => ({
	label: item[1],
	value: item[0],
}))

export const ARCADE_STOREID =
	process.env.REACT_APP_MODE === "production"
		? "6082f8eb2e08403a5bf1af80"
		: "6038b3d2cc62737a6387faa0"
export const ARCADE_STOREID_ST =
	process.env.REACT_APP_MODE === "production" ? "ST-1599344511175" : "ST-1592518478814"
